module.exports = __webpack_public_path__ + "static/media/level4.64a3e01c.png";